import * as t from 'io-ts'

const ParsecError = t.type({ error: t.string })
const ApiErrorIO = t.intersection([
  t.strict({
    responseCode: t.number,
  }),
  t.partial({ message: t.string }),
])

export const YantrixApiErrorIO = t.union([ParsecError, ApiErrorIO])

export type YantrixApiError = t.TypeOf<typeof YantrixApiErrorIO>

export const isYantrixApiError = YantrixApiErrorIO.is

export const formatYantrixApiError = (type: YantrixApiError) => {
  if (ParsecError.is(type)) {
    return type.error
  }
  if (ApiErrorIO.is(type)) {
    return `${type.message} (error code: ${type.responseCode})`
  }
  return 'Unknown API Error.'
}
